import { ChangeDetectorRef, Component, DoCheck, Input, IterableDiffer, IterableDiffers, OnInit, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { MetaUnidad } from '../../../../_models/meta-unidad';
import { UnidadEtapasService } from '../_services/unidad-etapas.service';
import { CustomAlertService } from '../../../../_components/custom-alert/custom-alert.service';
import { Meta } from '../../../../_models/meta';
import { Subscription } from 'rxjs';
import { startWith } from 'rxjs/operators';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { GlobalService } from 'src/app/_services/global.service';

@Component({
  selector: 'unidad-etapas-metas',
  standalone: false,
  templateUrl: 'unidad-etapas-metas.component.html',
  styleUrls: ['unidad-etapas-metas.component.scss',
    '../../unidad-etapas/unidad-etapas-generales.scss']
})

export class UnidadEtapasMetasComponent implements OnInit, DoCheck, OnDestroy {

  @Input() _metas: any[];
  @Input() unidadID: number;
  @Input() categorias: any[];
  @Input() isFamilia = false;
  @Input() materias: any[];
  @Input() areas: any[];

  metasRCategorias: number[] = [];

  metas: MetaUnidad[] = [];
  differ: IterableDiffer<any>;
  sortableOptions: any;

  unidadEtapasSubscribe;

  categoriaActiva = {};

  showMetasReferencia = false;

  filterForm = new UntypedFormGroup({
    materias: new UntypedFormControl([]),
    tiposMetas: new UntypedFormControl([]),
    alumnos: new UntypedFormControl(false)
  });
  filterFormMateriasSubscription: Subscription;
  filterFormAlumnosSubscription: Subscription;
  tiposMetasUnidad = [];

  constructor(differs: IterableDiffers,
    private cd: ChangeDetectorRef,
    private unidadEtapasService: UnidadEtapasService,
    private customAlertService: CustomAlertService,
    private snackBar: MatSnackBar,
    private globalService: GlobalService) {
    const that = this;
    this.differ = differs.find([]).create(null);

    this.sortableOptions = {
      handle: '.meta-unidad__handle',
      onSort: (event: any) => {
        // Array.from(event.to.children).map(meta => meta.dataset.metaId);
        that.ordenarMetas(event);

      },
      // handle: '.meta-mapping__handle'
    };
  }

  ngOnInit() {
    this.updateView(this._metas);
    const categoriasR = this.categorias.filter(cat => +cat.ordenAgrupador === 4);
    const categoriasU = this.categorias.find(cat => +cat.ordenAgrupador === 5);
    this.unidadEtapasSubscribe = this.unidadEtapasService.getUnidadEtapasObservable();

    this.unidadEtapasSubscribe.subscribe(data => {
      if (!data) {
        return false;
      }
      if (data.tipo === 'actualizar-lista-metas') {
        const metaUnidadIndice = this._metas.findIndex(meta => meta.meta.id === data.objetoUnidad.id);
        if (metaUnidadIndice > -1) {
          this._metas[metaUnidadIndice].meta = new Meta(data.objetoUnidad);
          this._metas[metaUnidadIndice].versionId = data.objetoUnidad.versionId;
          this._metas[metaUnidadIndice].criteriosCuenta = data.objetoUnidad.cuentaCriterios;
        }
        this.updateView(this._metas);
      }
    });

    categoriasR[0].categorias.map(subCat => {
      this.metasRCategorias.push(+subCat.id);
    });

    this.tiposMetasUnidad = categoriasU.categorias;
    this.filterForm.get('tiposMetas').setValue(this.tiposMetasUnidad.map(item => item.id));

    this.filterFormMateriasSubscription = this.filterForm.get('materias').valueChanges.subscribe(
      res => {
        this.updateView(this._metas);
      }
    );
    this.filterFormAlumnosSubscription = this.filterForm.get('alumnos').valueChanges.subscribe(
      res => {
        this.updateView(this._metas);
      }
    );
    this.filterFormAlumnosSubscription = this.filterForm.get('tiposMetas').valueChanges.pipe(
      startWith(
        this.filterForm.get('tiposMetas').value
      )
    ).subscribe(
      res => {
        for (const key in this.categoriaActiva) {
          if (Object.prototype.hasOwnProperty.call(this.categoriaActiva, key)) {
            this.categoriaActiva[key] = false;
          }
        }
        res.forEach(element => {
          this.categoriaActiva[element] = true;
        });
      }
    );

  }

  ngDoCheck() {
    const changes = this.differ.diff(this._metas);
    if (changes) {
      this.updateView(this._metas);
    }
  }

  eliminarMeta(id) {
  //   const metaIndex = this._metas.findIndex(meta => +meta.meta.id === +id);

  //   this.unidadEtapasService.quitarDeUnidad('meta', this.unidadID, id).subscribe(res => {
  //     this._metas.splice(metaIndex, 1);
  //     this.updateView(this._metas);
  //     this.snackBar.open(
  //       `La meta ${id} se ha eliminado de la unidad satisfactoriamente.`,
  //       null,
  //       { duration: 2500 }
  //     );
  //   }, err => {
  //     this.customAlertService.setCustomMessage({
  //       tipo: 'error',
  //       texto: `No ha sido eliminar la meta de la unidad. <br> ${err.error} <br> Código de error: ${err.statusText}`
  //     });
  //   });
  }

  ordenarMetas(event) {
    const arrIds = [];
    for (let i = 0; i < event.to.children.length; i++) {
      arrIds.push(event.to.children[i].dataset.metaId.toString());
    }
    const strIds = arrIds.toString();
    this.unidadEtapasService.ordenarMetas(strIds).subscribe(resp => {
      this.snackBar.open(
        `Las metas se han ordenado satisfactoriamente.`,
        null,
        { duration: 2250 });
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido ordenar las metas. <br> Código de error: ${err.statusText}`
      });
    });
  }

  updateView(metas) {
    this.filterForm.updateValueAndValidity();
    this.metas = metas.filter(this.filterFunction(this.filterForm, this)
    ).map(metaUnidad => {
      return new MetaUnidad(metaUnidad);
    });
    const that = this;
    setTimeout(() => {
      that.cd.detectChanges();
    }, 250);
  }

  filterFunction(form: UntypedFormGroup, component) {
    return function (meta) {
      const obj = meta.meta;
      return ((obj.areas ?
        component.globalService.intersectionArrays(obj.areas.map(item => item.id), form.value.materias).length > 0 : false)
        || form.value.materias.length === 0) &&
        ((obj.alumnosPendientes ? obj.alumnosPendientes.length > 0 : false) || form.value.alumnos === false);
    };
  }

  ngOnDestroy(): void {
    if (this.filterFormMateriasSubscription) {
      this.filterFormMateriasSubscription.unsubscribe();
    }
    if (this.filterFormAlumnosSubscription) {
      this.filterFormAlumnosSubscription.unsubscribe();
    }
  }
}
